module.exports = __webpack_public_path__ + "img/pd-img27.d57973f0.png";